// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracker-section {
  padding: 80px 0;
  background: linear-gradient(180deg, var(--section-bg) 0%, var(--bg-white) 100%);
}

.tracker-form {
  max-width: 640px;
  margin: 0 auto 2rem;
  text-align: center;
}

.tracker-form label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: var(--primary-dark-blue);
}

.tracker-form-row {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.tracker-form-row input {
  flex: 1;
  min-width: 220px;
  padding: 0.85rem 1rem;
  border: 2px solid var(--border-light);
  border-radius: 12px;
  font-size: 1rem;
  font-family: inherit;
}

.tracker-form-row input:focus {
  outline: none;
  border-color: var(--button-medium-blue);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.tracker-hint {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
}

.tracker-error {
  text-align: center;
  color: #dc2626;
  margin-bottom: 0.5rem;
}

.tracker-error-box {
  max-width: 640px;
  margin: 0 auto 1.5rem;
  text-align: center;
}

.tracker-error-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 0.75rem;
}

.tracker-result {
  max-width: 900px;
  margin: 0 auto;
  background: var(--bg-white);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 12px 40px var(--shadow-color);
  border: 1px solid var(--border-light);
}

.tracker-result-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-light);
}

.tracker-result-label {
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
  margin: 0;
}

.tracker-result-number {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--primary-dark-blue);
  margin: 0.25rem 0 0;
}

.tracker-result-status {
  text-align: end;
}

.tracker-result-updated {
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
  margin: 0.5rem 0 0;
}

.tracker-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;
  font-size: 0.95rem;
  color: var(--text-medium-gray);
}

.tracker-timeline {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.75rem;
}

.tracker-step {
  position: relative;
  border: 2px solid var(--border-light);
  background: var(--section-light-gray);
  border-radius: 14px;
  padding: 1rem 0.5rem;
  transition: all 0.3s ease;
  font-family: inherit;
  color: var(--text-dark-gray);
  text-align: center;
}

.tracker-step.done {
  border-color: var(--accent-teal);
  background: rgba(13, 148, 136, 0.08);
}

.tracker-step.active {
  border-color: var(--button-medium-blue);
  background: rgba(37, 99, 235, 0.1);
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);
}

.tracker-step-icon {
  display: block;
  font-size: 1.75rem;
  margin-bottom: 0.35rem;
}

.tracker-step-label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.35;
}

.tracker-step-date {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.68rem;
  color: var(--footer-medium-gray);
}

.tracker-step-note {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.68rem;
  color: var(--primary-dark-blue);
}

.tracker-step-pulse {
  position: absolute;
  inset: -4px;
  border-radius: 16px;
  border: 2px solid var(--button-medium-blue);
  animation: trackerPulse 1.5s ease infinite;
  pointer-events: none;
}

@keyframes trackerPulse {
  0%, 100% { opacity: 0.4; transform: scale(1); }
  50% { opacity: 0; transform: scale(1.05); }
}

.tracker-portal-cta {
  text-align: center;
  margin-top: 2rem;
}

@media (max-width: 768px) {
  .tracker-timeline {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ShipmentTrackerDemo.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,sBAAsB,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".tracker-section {\n  padding: 80px 0;\n  background: linear-gradient(180deg, var(--section-bg) 0%, var(--bg-white) 100%);\n}\n\n.tracker-form {\n  max-width: 640px;\n  margin: 0 auto 2rem;\n  text-align: center;\n}\n\n.tracker-form label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  color: var(--primary-dark-blue);\n}\n\n.tracker-form-row {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.tracker-form-row input {\n  flex: 1;\n  min-width: 220px;\n  padding: 0.85rem 1rem;\n  border: 2px solid var(--border-light);\n  border-radius: 12px;\n  font-size: 1rem;\n  font-family: inherit;\n}\n\n.tracker-form-row input:focus {\n  outline: none;\n  border-color: var(--button-medium-blue);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.tracker-hint {\n  margin-top: 0.75rem;\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n}\n\n.tracker-error {\n  text-align: center;\n  color: #dc2626;\n  margin-bottom: 0.5rem;\n}\n\n.tracker-error-box {\n  max-width: 640px;\n  margin: 0 auto 1.5rem;\n  text-align: center;\n}\n\n.tracker-error-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: center;\n  margin-top: 0.75rem;\n}\n\n.tracker-result {\n  max-width: 900px;\n  margin: 0 auto;\n  background: var(--bg-white);\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 12px 40px var(--shadow-color);\n  border: 1px solid var(--border-light);\n}\n\n.tracker-result-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.tracker-result-label {\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n  margin: 0;\n}\n\n.tracker-result-number {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  margin: 0.25rem 0 0;\n}\n\n.tracker-result-status {\n  text-align: end;\n}\n\n.tracker-result-updated {\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n  margin: 0.5rem 0 0;\n}\n\n.tracker-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 2rem;\n  font-size: 0.95rem;\n  color: var(--text-medium-gray);\n}\n\n.tracker-timeline {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.75rem;\n}\n\n.tracker-step {\n  position: relative;\n  border: 2px solid var(--border-light);\n  background: var(--section-light-gray);\n  border-radius: 14px;\n  padding: 1rem 0.5rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  color: var(--text-dark-gray);\n  text-align: center;\n}\n\n.tracker-step.done {\n  border-color: var(--accent-teal);\n  background: rgba(13, 148, 136, 0.08);\n}\n\n.tracker-step.active {\n  border-color: var(--button-medium-blue);\n  background: rgba(37, 99, 235, 0.1);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);\n}\n\n.tracker-step-icon {\n  display: block;\n  font-size: 1.75rem;\n  margin-bottom: 0.35rem;\n}\n\n.tracker-step-label {\n  display: block;\n  font-size: 0.78rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.tracker-step-date {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.68rem;\n  color: var(--footer-medium-gray);\n}\n\n.tracker-step-note {\n  display: block;\n  margin-top: 0.25rem;\n  font-size: 0.68rem;\n  color: var(--primary-dark-blue);\n}\n\n.tracker-step-pulse {\n  position: absolute;\n  inset: -4px;\n  border-radius: 16px;\n  border: 2px solid var(--button-medium-blue);\n  animation: trackerPulse 1.5s ease infinite;\n  pointer-events: none;\n}\n\n@keyframes trackerPulse {\n  0%, 100% { opacity: 0.4; transform: scale(1); }\n  50% { opacity: 0; transform: scale(1.05); }\n}\n\n.tracker-portal-cta {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n@media (max-width: 768px) {\n  .tracker-timeline {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
